/**
 * Normalize a QUDT/ISO quantity-kind label for display.
 *
 * The upstream data is inconsistent: some labels are Title Case
 * ("Currency", "Boiling Point Temperature"), some are lowercase
 * ("mass", "length", "acceleration"), and a few are all-caps acronyms
 * ("API Gravity"). Rendered as-is they look broken in chip strips and
 * badges where they sit side by side.
 *
 * Rule: capitalize each word's first letter unless the word is already
 * mixed-case or all-caps (preserving acronyms like "API", "USD").
 */
export function formatQkindLabel(label: string | null | undefined): string {
  if (!label) return "";
  return label
    .split(/\s+/)
    .map((w) => {
      if (w.length === 0) return w;
      if (w === w.toUpperCase()) return w; // ACRONYM
      if (w === w.toLowerCase()) return w[0].toUpperCase() + w.slice(1);
      return w; // already mixed-case, trust source
    })
    .join(" ");
}
